// Recent Searches Utility
class RecentSearchesManager {
  constructor() {
    this.storageKey = 'pharma_recent_searches';
    this.maxSearches = 20; // Keep only the 20 most recent searches
  }

  // Get all recent searches
  getRecentSearches() {
    try {
      const searches = localStorage.getItem(this.storageKey);
      return searches ? JSON.parse(searches) : [];
    } catch (error) {
      console.error('Error getting recent searches:', error);
      return [];
    }
  }

  // Add a new search
  addSearch(searchData) {
    try {
      const searches = this.getRecentSearches();

      // Create search entry
      const searchEntry = {
        id: Date.now().toString(),
        ...searchData,
        timestamp: new Date().toISOString(),
        query: searchData.query || '',
        database: searchData.database || 'general',
        resultsCount: searchData.resultsCount || 0
      };

      // Remove duplicate searches (same query and database)
      const filteredSearches = searches.filter(search =>
        !(search.query === searchEntry.query && search.database === searchEntry.database)
      );

      // Add new search to the beginning
      filteredSearches.unshift(searchEntry);

      // Keep only the most recent searches
      const limitedSearches = filteredSearches.slice(0, this.maxSearches);

      localStorage.setItem(this.storageKey, JSON.stringify(limitedSearches));
      return searchEntry;
    } catch (error) {
      console.error('Error adding search:', error);
      return null;
    }
  }

  // Remove a specific search
  removeSearch(searchId) {
    try {
      const searches = this.getRecentSearches();
      const filteredSearches = searches.filter(search => search.id !== searchId);
      localStorage.setItem(this.storageKey, JSON.stringify(filteredSearches));
      return true;
    } catch (error) {
      console.error('Error removing search:', error);
      return false;
    }
  }

  // Clear all recent searches
  clearAllSearches() {
    try {
      localStorage.removeItem(this.storageKey);
      return true;
    } catch (error) {
      console.error('Error clearing searches:', error);
      return false;
    }
  }

  // Get searches for a specific database
  getSearchesByDatabase(database) {
    const searches = this.getRecentSearches();
    return searches.filter(search => search.database === database);
  }

  // Format timestamp for display
  formatTimestamp(timestamp) {
    const date = new Date(timestamp);
    const now = new Date();
    const diffInHours = Math.floor((now - date) / (1000 * 60 * 60));

    if (diffInHours < 1) {
      return 'Just now';
    } else if (diffInHours < 24) {
      return `${diffInHours} hour${diffInHours > 1 ? 's' : ''} ago`;
    } else {
      const diffInDays = Math.floor(diffInHours / 24);
      return `${diffInDays} day${diffInDays > 1 ? 's' : ''} ago`;
    }
  }
}

const recentSearchesManager = new RecentSearchesManager();

export default recentSearchesManager;